import {BFormGroup, BFormInput, BFormTextarea, BModal} from "bootstrap-vue";
import ProductSelect from '@@/core/components/shared/ProductSelect/ProductSelect'

export default {
  name: 'StoreForm',
  components: { ProductSelect,BModal, BFormInput, BFormTextarea, BFormGroup },
  props: {
    products: Array,
    stores: Array,
    mode: {
      default: "increment",
      type: String,
    },
    value: [Object, String],
  },
  data() {
    return {
      disabled: false,
      quantity: 0,
      url: `admin/stores/${this.store_id}/change-balance`,
      disabledBtn: false,
      store_id: null,
      varieties: [],
      showVarieties: false,
      store: this.value,
    };
  },
  watch: {
    products(newVal) {
      return newVal.forEach((product, index) => {
        product.index = index;
      });
    },
    store(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.store = newVal;
    },

  },
  methods: {
    async submit() {
      this.disabled = true;
      try {
        console.log(this.store_id);
        let formData = new FormData(this.$refs.form);
        formData.append(
          "variety_id",
          this.store.selectedVariety != null
            ? this.store.selectedVariety.id
            : ""
        );
        formData.append(
          "type",
          this.mode == "increment" ? "increment" : "decrement"
        );
        const response = await this.$axios.post(`admin/stores/${this.store_id}/change-balance`, formData);
        this.$root.notify(response.data.message, "success");
        const stores = await this.$axios.get("admin/stores/transactions");
        // this.$root.$emit("bv::hide::modal", "store-modal");
        console.log(stores.data.data.transactions);
        this.$emit('dataSubmitted', stores.data.data.transactions);
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    },
    setStore(balance) {
      this.products[this.store.selectedProduct.index].varieties[
        this.store.selectedVariety.index
      ].quantity = balance;
    },
    selectVariety(v) {
      console.log(this.store)
      this.store.selectedVariety = v
    }
  },
};
